/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forside_Redact_AliasInputs */

const da_forside_redact_alias = /** @type {(inputs: Forside_Redact_AliasInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elev 1`)
};

/** @type {(inputs: Forside_Redact_AliasInputs) => LocalizedString} */
const en_forside_redact_alias = da_forside_redact_alias;

/**

* @param {Forside_Redact_AliasInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const forside_redact_alias = /** @type {((inputs?: Forside_Redact_AliasInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forside_Redact_AliasInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forside_redact_alias(inputs)
	return /** @type {LocalizedString} */ ("Elev 1")
});